import DOMPurify from "dompurify";

const toHtmlString = (value) => (value == null ? "" : String(value));

// DOMPurify 預設會拿掉 target，而文章內文有大量 target="_blank" 的連結，拿掉就改成在後台原分頁開啟。
// 只放行 _blank，並一律補 rel，不讓新分頁經由 window.opener 把後台分頁導走。
DOMPurify.addHook("uponSanitizeAttribute", (_node, data) => {
    if (data.attrName === "target" && data.attrValue === "_blank") data.forceKeepAttr = true;
});
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.getAttribute?.("target") === "_blank") node.setAttribute("rel", "noopener noreferrer");
});

// 資料綁定的 HTML 一律走這裡而不是 v-html：會友自填的欄位（姓名、報名表答案）
// 後端原樣回傳、沒有跳脫。
export const sanitizeHtml = (value) => DOMPurify.sanitize(toHtmlString(value));

// 編輯器載入的內文會原封不動存回 DB，預設設定會刪掉既有文章裡嵌入的 YouTube / 地圖 iframe。
// src 仍受 DOMPurify 的 URI 檢查（javascript: / data: 不會過），srcdoc 不在白名單。
const EDITOR_CONFIG = {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"],
};
export const sanitizeEditorHtml = (value) => DOMPurify.sanitize(toHtmlString(value), EDITOR_CONFIG);

// 取純文字不能用 document.createElement("div").innerHTML：那個 div 屬於目前頁面，
// <img onerror> 一樣會載入、執行。DOMParser 產生的是 inert document。
export const htmlText = (value) =>
    new DOMParser().parseFromString(toHtmlString(value), "text/html").body.textContent ?? "";

const render = (el, { value, oldValue }) => {
    if (value !== oldValue) el.innerHTML = sanitizeHtml(value);
};

export default { beforeMount: render, beforeUpdate: render };
